var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectable-list",class:{ isSelecting: this.state === 'selecting' }},[_vm._t("default",null,{"items":_vm.items,"checked":_vm.checked,"toggle":_vm.toggle,"enter":_vm.enter,"leave":_vm.leave,"down":_vm.down})],2)}
var staticRenderFns = []

export { render, staticRenderFns }